(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("mobx"), require("mobxReact"), require("ReactDOM"), require("sbInternalMsgBus"));
	else if(typeof define === 'function' && define.amd)
		define("sbCommonLib", ["React", "mobx", "mobxReact", "ReactDOM", "sbInternalMsgBus"], factory);
	else if(typeof exports === 'object')
		exports["sbCommonLib"] = factory(require("React"), require("mobx"), require("mobxReact"), require("ReactDOM"), require("sbInternalMsgBus"));
	else
		root["sbCommonLib"] = factory(root["React"], root["mobx"], root["mobxReact"], root["ReactDOM"], root["sbInternalMsgBus"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__14__, __WEBPACK_EXTERNAL_MODULE__58__) {
return 